export default {
  showDetails(orderId) {
    Routes.setRoute(`/transactions/${orderId}`);
  },

  goToTransactions() {
    Routes.setRoute('/transactions');
  },

  goToRefunds() {
    Routes.setRoute('/transactions/refunds');
  },

  showRefundDetails(number) {
    Routes.setRoute(`/transactions/refunds/${number}`);
  },

  showRefundRestrictions(number) {
    Routes.setRoute(`/transactions/${number}/refund-restrictions`);
  }

};
